<template>
  <v-container :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="8" class="pt-6 pb-6">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="headline font-weight-light">
          Profesori u školi : {{ school_name }}
        </span>
      </v-col>
      <v-col cols="4" md="4" align="right">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on }">
            <v-btn icon large class="ml-5" align="right" @click="exportDataExcel()">
              <v-icon large color="primary" dark v-on="on">
                mdi-microsoft-excel
              </v-icon>
            </v-btn>
          </template>
          <span>Izvoz podataka u Excel</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="4">
        <v-text-field
            outlined
            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>

      <v-col cols="12" md="4">
        <v-autocomplete
            outlined
            :items="subjects"
            item-text="name"
            item-value="id"
            hide-details
            label="Odaberi predmet..."
            v-model="selected_subject"
            dense
            @change="getDataTable()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="dataTable"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:[`item.teacher_subjects`]>
            <span style="color: #084776">{{ select_subject_title }}</span>
          </template>
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>
          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiV2 from "../../services/ApiV2";

export default {
  name: "TeachersInCantonForSchoolYear",
  params: {
    school_id: {
      type: Number
    },

  },
  data() {
    return {
      school_id: null,
      school_name: null,
      dataTable: [],
      headers: [
        {
          text: "Ime i prezime",
          value: "name",
        },
        {
          text: "Email",
          value: "email",
        },
      ],
      search: "",
      school_year_id: null,
      subjects: [],
      selected_subject: null,
    };
  },
  mounted() {
    this.school_id = this.$route.query.school;
    this.school_year_id = this.$route.query.year;
    this.getDataTable();
    this.getSubjects();
  },
  methods: {
    async exportDataExcel() {
      const response = await apiV2.get('teachers_per_cantons_and_schools/export', {
        params: {
          school_id: this.school_id,
          school_year_id: this.school_year_id,
          subject_id: this.selected_subject
        },
        responseType: 'blob'
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', 'Popis nastavnika u školi.xlsx');
      document.body.appendChild(link);

      link.click();
      window.URL.revokeObjectURL(url);
    },
    getDataTable() {

      if (this.selected_subject) {
        this.$axios.get(`ostalo/izvjestaj/nastavnici/skolama/${this.school_id}/god/${this.school_year_id}/${this.selected_subject}`)
            .then((response) => {
              this.dataTable = response.data.professors
              this.school_name = response.data.school_name
            })
      } else {
        this.$axios.get(`ostalo/izvjestaj/nastavnici/skolama/${this.school_id}/god/${this.school_year_id}`)
            .then((response) => {
              this.dataTable = response.data.professors
              this.school_name = response.data.school_name
            })
      }

    },
    getSubjects() {
      this.axios.get(`ostalo/izvjestaj/predmeti/skolama/${this.school_id}/god/${this.school_year_id}`, {
        params: {
          perPage: -1
        }
      })
          .then(response => {
            this.subjects = response.data[0];
          });
    },


  }
}
</script>

<style scoped>

</style>
